import React from 'react';
import { useAppSelector, useAppDispatch } from '../ducks/hooks';
import { MessageBar } from '../providers/harmony-scope/lazy-enablers';
import { EBannerSource, TBannerMessage, clearBannerMessage } from '../ducks/banner-messages/duck-banner-messages';
import RichTextRender from './rich-text-editor/rich-text-render';

export const BannerMessagesContainer = () => {
  const bannerMessages = useAppSelector((state) => state.bannerMessages);
  const dispatch: any = useAppDispatch();

  const onAfterHide = (id: string) => {
    dispatch(clearBannerMessage(id));
  };

  return (
    // Forces return as JSX.Element, empty if no errors

    <>
      {Object.values(bannerMessages)?.map((bannerMessage: TBannerMessage) => (
        <MessageBar
          key={`key-bannermessageid-${bannerMessage.id}`}
          appearance={`${bannerMessage.appearance}`}
          onHeMessageBarAfterHide={() => onAfterHide(bannerMessage.id.toString())}
          open
        >
          {bannerMessage.source === EBannerSource.CustomNotifications ? <RichTextRender delta={bannerMessage.message} /> : `${bannerMessage.message}`}
        </MessageBar>
      ))}
    </>
  );
};
